export const PRESTORED_PRICE: number = 3000;
export const FLAVOUR_NOTE_PRICE: number = 1250;
